import { render } from "./CarrouselHome.vue?vue&type=template&id=254eedf9&scoped=true"
import script from "./CarrouselHome.vue?vue&type=script&lang=js"
export * from "./CarrouselHome.vue?vue&type=script&lang=js"

import "./CarrouselHome.vue?vue&type=style&index=0&id=254eedf9&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254eedf9"]])

export default __exports__